import {Injectable, signal} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {KtServiceFilterForm, KtServiceFilterModel} from '../models/kt-filter.model';

@Injectable({providedIn: 'root'})
export class KtServicesFilterService {
  public readonly filtersValue = signal<KtServiceFilterModel>(this.buildDefaultFilters());
  public readonly toggleModal = signal<boolean>(false);

  private readonly filters$ = new BehaviorSubject<KtServiceFilterModel>(this.filtersValue());

  public get form(): KtServiceFilterForm {
    return new FormGroup({
      TripReference: new FormControl<string | null>(null),
      ServiceName: new FormControl<string | null>(null),
      ProductTypeName: new FormControl<string | null>(null),
      VendorName: new FormControl<string | null>(null),
      ServiceStartDateFrom: new FormControl<Date | null>(null),
      ServiceStartDateTo: new FormControl<Date | null>(null),
    });
  }

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: KtServiceFilterModel): void {
    this.filtersValue.set(value);
    this.filters$.next(value);
  }

  private buildDefaultFilters(): KtServiceFilterModel {
    return {
      TripReference: null,
      ServiceName: null,
      ProductTypeName: null,
      VendorName: null,
      ServiceStartDateFrom: null,
      ServiceStartDateTo: null,
      ReloadGrid: false,
    };
  }
}
